import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Layout from "./Layout";
import { useFormik } from "formik";
import * as Yup from "yup";
//api calls
import { CreateUser } from "../Api/UserOperations/CreateUser";
import { useParams } from "react-router-dom";

const Register = () => {
  const params = useParams();
  const navigate = useNavigate();

  const { handleSubmit, handleChange, handleBlur, touched, values, errors } =
    useFormik({
      initialValues: {
        Username: "",
        Email: "",
        Referar: params?.refID?.length > 0 ? params.refID : "",
        Password: "",
      },
      validationSchema: Yup.object({
        Username: Yup.string().required("Username required!"),
        Email: Yup.string().required("Email required!"),
        Referar: Yup.string().required("Referar required!"),
        Password: Yup.string().required("Password required"),
      }),
      onSubmit: async (values) => {
        const gidecekData = {
          ...values,
          RegisterDate: Date.now(),
          Blok: false,
          Level: 0,
          isEmailVerify: false,
        };

        const { data } = await CreateUser(gidecekData);
        if (data.status === true) {
          Swal.fire("Registration Successful!", `${data.msg}`, "success");
          setTimeout(() => {
            navigate("/Login");
          }, 500);
        } else {
          Swal.fire("Registration Failed!", `${data.msg}`, "error");
        }
      },
    });

  return (
    <Layout>
      <section className="h-auto mx-auto max-w-screen-xl px-4  pb-28 sm:pb-0">
        <div className="px-6 h-auto text-gray-800">
          <div className="flex xl:justify-center lg:justify-between justify-center items-center flex-wrap h-full g-6">
            <div className="grow-0 shrink-1 md:shrink-0 basis-auto xl:w-6/12 lg:w-6/12 md:w-9/12 mb-12 md:mb-0">
              <img
                src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
                className="w-full"
                alt="Make Money Register"
              />
            </div>
            <div className="xl:ml-20 xl:w-5/12 lg:w-5/12 md:w-8/12 mb-12 md:mb-0">
              <form onSubmit={handleSubmit}>
                <div className="mb-6">
                  <input
                    onChange={handleChange}
                    value={values.Username}
                    onBlur={handleBlur}
                    name="Username"
                    type="text"
                    className={`form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`}
                    placeholder="Username"
                  />
                  {touched.Username && errors.Username && (
                    <span className="text-red-500 py-2">{errors.Username}</span>
                  )}
                </div>
                <div className="mb-6">
                  <input
                    onChange={handleChange}
                    value={values.Email}
                    onBlur={handleBlur}
                    name="Email"
                    type="email"
                    className="form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    placeholder="Email address"
                  />
                  {touched.Email && errors.Email && (
                    <span className="text-red-500 py-2">{errors.Email}</span>
                  )}
                </div>
                <div className="mb-6">
                  <input
                    onChange={handleChange}
                    value={values.Referar}
                    onBlur={handleBlur}
                    name="Referar"
                    type="text"
                    className="form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    placeholder="Referral"
                  />
                  {touched.Referar && errors.Referar && (
                    <span className="text-red-500 py-2">{errors.Referar}</span>
                  )}
                </div>

                <div className="mb-6">
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.Password}
                    name="Password"
                    type="password"
                    className="form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    placeholder="Password"
                  />
                  {touched.Password && errors.Password && (
                    <span className="text-red-500 py-2">{errors.Password}</span>
                  )}
                </div>

                <div className="text-center lg:text-left">
                  <button
                    type="submit"
                    className="w-full inline-block px-7 py-3 bg-blue-600 text-white font-medium text-sm leading-snug uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Register
                  </button>
                  <p className="text-sm font-semibold mt-2 pt-1 mb-0">
                    have an account?
                    <Link
                      to="/Login"
                      className="text-red-600 hover:text-red-700 focus:text-red-700 transition duration-200 ease-in-out pl-1"
                    >
                      Login
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};
export default Register;
